<app-header></app-header>

<div>
  <div class="card-container">
    <div class="card">
      <div class="card-content">
        <h1 class="card-title">{{courseData?.trainingCourseName}}</h1>
        <p class="card-subtitle">
          {{courseData?.trainingCourseDescription}}
        </p>

        <div class="card-stats">
          <div>
            <button class="btn btn-primary" (click)="joinMeeting(todaylivelatestsession,attendedId)"
              *ngIf="isLoggedIn && showJoinButton" [disabled]="!canJoinMeeting">

              <span class="live-dotgreen" style="margin-right:5px;"></span>
              <strong style="margin-right:5px;">See you</strong>
              <span>{{todayDisplay}}</span>

            </button>
            <!-- <button class="btn btn-primary onlyformobile" (click)="joinMeeting()" *ngIf="isLoggedIn && slotDate">
              <span class="live-dotgreen" style="margin-right: 5px;"></span><strong style="margin-right: 5px;">Join
                </strong><span style="margin-left: 5px;">{{slotDate}}</span>
            </button> -->
            <button (click)="joinMeeting(todaylivelatestsession,attendedId)" class="btn-primary" *ngIf="!isLoggedIn">
              Get Started
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-arrow-right rigtharr" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      <div class="card-image">
        <img src="Training- Course.png" alt="Course Image" />
      </div>
    </div>
  </div>

  <div style="width: auto; background-color: #121212; color: white !important">
    <div class="course-review-container">
      <div class="course-header">
        <h1>{{courseData?.trainingCourseTitle}}</h1>
        <div class="course-meta">
          <span class="bestseller">Bestseller</span>
          <span class="rating">{{courseData?.averageRating | number:'1.1-1'}} ★ (50,038 ratings)</span>
        </div>
      </div>
      <div class="course-content">
        <div class="what-youll-learn">
          <h2>Structure: </h2>
          <div class="learn-items">
            <div class="learn-column" [innerHtml]="courseData?.trainingCourseLearningDescription">

            </div>
          </div>
        </div>

        <div class="course-content">
          <h2>Course content</h2>
          <div class="sections-meta">
            {{courseData?.modulesLength}} module • {{courseData?.lecturesLength}} lectures •
            {{formatDuration(courseData?.totalDuration)}} total length
          </div>
        </div>
        <div class="course-progress-container">
          <div class="course-info">
            <span class="course-title">{{courseData?.trainingCourseName}}</span>
            <span class="course-percent">{{conmpltedCoursePer}}</span>
          </div>

          <div class="progress-bar">
            <div class="progress-fill" [ngStyle]="{'width': conmpltedCoursePer}"></div>
          </div>
        </div>

        <!-- Video Player Modal -->
        <div class="video-modal" *ngIf="showVideoModal">
          <div class="modal-overlay" (click)="closeVideo()"></div>

          <div class="modal-content" [ngClass]="{ fullscreen: isFullscreen }">
            <button class="close-modal" (click)="closeVideo()">×</button>

            <!-- Fullscreen toggle -->
            <button *ngIf="isVimeo(currentVideo)" class="close-modal" style="right: 40px" (click)="toggleFullscreen()">
              ⛶
            </button>

            <iframe #videoIframe *ngIf="isVimeo(currentVideo) || isYouTube(currentVideo)" frameborder="0"
              allow="autoplay; fullscreen" allowfullscreen>
            </iframe>

            <!-- Normal video -->
            <video #html5Video *ngIf="!isVimeo(currentVideo) && !isYouTube(currentVideo)" controls autoplay muted
              playsinline></video>
          </div>
        </div>
        <div class="video-modal" *ngIf="showVideoModalforSlot">
          <div class="modal-content  height90vh" [ngClass]="{ fullscreen: isFullscreen }">
            <!-- <div class="modal-overlay"></div> -->
            <button class="close-modal" (click)="closeVideoforSlot()">×</button>
            <app-book-live-session-slot [courseData]="livesessionname"></app-book-live-session-slot>
          </div>
        </div>
        <!-- Quiz Modal -->
        <div class="quiz-modal" *ngIf="showQuizModal">
          <div class="modal-overlay"></div>
          <div class="modal-content quiz-page">
            <h3 class="quiz-title">
              <span class="q-label">Q.</span> {{ currentQuestion?.question }}
            </h3>

            <!-- MCQ -->
            <div *ngIf="currentQuestion?.type === 'mcq'" class="quiz-options">
              <label class="quiz-option">
                <input type="radio" name="quizOption" [value]="currentQuestion?.option1" [(ngModel)]="userAnswer" />
                {{ currentQuestion?.option1 }}
              </label>
              <label class="quiz-option">
                <input type="radio" name="quizOption" [value]="currentQuestion?.option2" [(ngModel)]="userAnswer" />
                {{ currentQuestion?.option2 }}
              </label>
              <label class="quiz-option">
                <input type="radio" name="quizOption" [value]="currentQuestion?.option3" [(ngModel)]="userAnswer" />
                {{ currentQuestion?.option3 }}
              </label>
              <label class="quiz-option">
                <input type="radio" name="quizOption" [value]="currentQuestion?.option4" [(ngModel)]="userAnswer" />
                {{ currentQuestion?.option4 }}
              </label>
            </div>

            <!-- One word -->
            <div *ngIf="currentQuestion?.type === 'oneword'" class="quiz-input">
              <input [(ngModel)]="userAnswer" placeholder="Type answer..." />
            </div>

            <!-- Submit -->
            <div class="quiz-actions">
              <button class="quiz-btn primary" (click)="submitAnswer(userAnswer)">
                Submit
              </button>
            </div>
          </div>
        </div>
        <div class="chapter-card" *ngFor="let chapter of chapters; let i = index">
          <div class="chapter-header" (click)="toggleChapter(i)">
            <div class="left">
              <span class="toggle-icon">
                <i class="bi" [ngClass]="chapter.open ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
              </span>

              <h3>{{ chapter.moduleName }}</h3>
            </div>

            <span class="module" *ngIf="formatDuration(chapter.duration)">{{ formatDuration(chapter.duration) }}</span>
          </div>

          <div class="chapter-body" [class.open]="chapter.open">
            <div class="video-row" *ngFor="let video of chapter.videos">
              <span class="video-title" *ngIf="video.lectureType !== 'livesession'"><img *ngIf="isLoggedIn"
                  src="Video-icon.png" class="pad1rem" (click)="playVideo(video.url, video.lectureRef)" />
                <img *ngIf="!isLoggedIn" src="Video-icon.png" class="pad1rem"
                  (click)="joinMeeting(TodayJoinLink[0],attendedId)" />
                {{ video.lectureName }}

                <span class="status-icon" *ngIf="video.lectureRef as lec">
                  <i class="bi bi-check-circle-fill completed" *ngIf="lec.completed === 1"></i>

                  <i class="bi bi-play-circle-fill in-progress" *ngIf="lec.completed === 0 && lec.lastWatched > 0"></i>

                  <!-- Not Started -->
                  <i class="bi bi-circle pending" *ngIf="lec.completed === 0 && lec.lastWatched === 0"></i>
                </span>
              </span>
              <span class="video-title" *ngIf="video.lectureType === 'livesession'">
                <img src="Video-icon.png" class="pad1rem" />
                <span class="video-title-name" (click)="openReviews(video.lectureId)">{{ video.lectureName }}</span>
                <div class="star-rating mobile">
                  <span *ngFor="let star of [1, 2, 3, 4, 5]" class="star"
                    [class.active]="star <= getDisplayedRating(video)"
                    [class.half]="star > getDisplayedRating(video) && star - 0.5 <= getDisplayedRating(video)"
                    [class.disabled]="!isPastDateAttended(
                      video.bookedslotDate,
                      video.bookedslotime,
                      video.isbooked,
                      video.Completed,
                      video.isExpired
                    )" (click)="isPastDateAttended(
                      video.bookedslotDate,
                      video.bookedslotime,
                      video.isbooked,
                      video.Completed,
                      video.isExpired
                    ) && selectLectureRating(video.sessionid, star)">
                    ★
                  </span>
                </div>
              </span>
              <span class="status-icon" *ngIf="video.lectureType === 'livesession'">
                <div class="star-rating dekstop d-flex">
                  <span *ngFor="let star of [1, 2, 3, 4, 5]" class="star"
                    [class.active]="star <= getDisplayedRating(video)"
                    [class.half]="star > getDisplayedRating(video) && star - 0.5 <= getDisplayedRating(video)"
                    [class.disabled]="!isPastDateAttended(
                      video.bookedslotDate,
                      video.bookedslotime,
                      video.isbooked,
                      video.Completed,
                      video.isExpired
                    )" (click)="isPastDateAttended(
                      video.bookedslotDate,
                      video.bookedslotime,
                      video.isbooked,
                      video.Completed,
                      video.isExpired
                    ) && selectLectureRating(video.sessionid, star)">
                    ★
                  </span>
                  <div class="rating-section">
                    <button (click)="ratingSubmit(video.rating)" type="button" class="rating-btn"
                      [disabled]="!isPastDateAttended(video.bookedslotDate,video.bookedslotime,video.isbooked,video.Completed,video.isExpired)"
                      [ngClass]="{'disabled': !isPastDateAttended(video.bookedslotDate,video.bookedslotime,video.isbooked,video.Completed,video.isExpired)}">
                      Rate
                    </button>
                  </div>
                </div>
                <button
                  *ngIf="(video.bookedslotDate === null || video.bookedslotDate === undefined) && isLoggedIn && (video.isExpired !== null) && !video.isdisabled"
                  class="join-btn"
                  (click)="openVideoforSlot(video.lectureName, video.lectureId, chapter.moduleName, video.bookingid,  video.sessionid,'editFalse' )">
                  <span class="live-dot"></span> Book Slot
                </button>
                <button
                  *ngIf="(video.bookedslotDate === null || video.bookedslotDate === undefined) && isLoggedIn && (video.isExpired === true) && video.isdisabled"
                  class="join-btn dull" (click)="openNotbookedAlert()">
                  <span class="live-dot"></span> Slot Not Booked
                </button>
                <button
                  *ngIf="(video.bookedslotDate === null || video.bookedslotDate === undefined) && isLoggedIn && (video.isExpired === null)"
                  [disabled]="bookflag(video.isdisabled)" [class.disabled-btn]="bookflag(video.isdisabled)"
                  class="join-btn"
                  (click)="openVideoforSlot(video.lectureName, video.lectureId, chapter.moduleName, video.bookingid,  video.sessionid,'editFalse' )">
                  <span class="live-dot"></span> Upcoming Session
                </button>
                <button *ngIf="!isLoggedIn" class="join-btn" (click)="OpenLogin()">
                  <span class="live-dot"></span> Book Slot
                </button>
                <button *ngIf="video.bookedslotDate && isLoggedIn && video.isExpired === false" class="join-btn"
                  (click)="JoiSession(video.url,video.bookedslotDate,video.bookedslotime,video.bookingid)">
                  <span class="live-dotgreen"></span><strong>See you</strong>
                  <span>{{formatSlotDate(video.bookedslotDate,video.bookedslotime)}}</span>

                </button>
                <!-- <button class="join-btn" [disabled]="isPastDateAttended(video.bookedslotDate,video.bookedslotime,video.isbooked,video.Completed)"
                  [ngClass]="{'past-btn': isPastDateAttended(video.bookedslotDate,video.bookedslotime,video.isbooked,video.Completed)}"
                  *ngIf="video.bookedslotDate && isLoggedIn && isPastDateAttended(video.bookedslotDate,video.bookedslotime,video.isbooked,video.Completed)">

                  <span class="live-dot"></span>
                  <span>{{ formatSlotDate(video.bookedslotDate,video.bookedslotime) }}</span>
                </button> -->
                <button class="join-btn"
                  (click)="openattendedAlert(video.bookedslotDate,video.bookedslotime,video.sessionid)"
                  [ngClass]="{'past-btn': isPastDateAttended(video.bookedslotDate,video.bookedslotime,video.isbooked,video.Completed,video.isExpired)}"
                  *ngIf="video.bookedslotDate && isLoggedIn && isPastDateAttended(video.bookedslotDate,video.bookedslotime,video.isbooked,video.Completed,video.isExpired)">

                  <span class="live-dot"></span>
                  <span>{{ formatSlotDate(video.bookedslotDate,video.bookedslotime) }}</span>
                </button>

                <!-- <button (click)="feebackopen(video.sessionid)" class="feedback-btn"
                  *ngIf="video.bookedslotDate && isLoggedIn && isPastDateAttended(video.bookedslotDate,video.bookedslotime,video.isbooked,video.Completed,video.isExpired)">
                  <i class="fas fa-comment-dots"></i>
                </button> -->
                <button class="join-btn"
                  (click)="openmissedAlert(video.bookedslotDate,video.bookedslotime,video.sessionid)"
                  [ngClass]="{'missed': isPastDateAttendedMissed(video.bookedslotDate,video.bookedslotime,video.isbooked,video.Completed,video.isExpired)}"
                  *ngIf="video.bookedslotDate && isLoggedIn && isPastDateAttendedMissed(video.bookedslotDate,video.bookedslotime,video.isbooked,video.Completed,video.isExpired)">

                  <span class="live-dot"></span>
                  <span>{{ formatSlotDate(video.bookedslotDate,video.bookedslotime) }}</span>
                </button>
                <button class="feedback-btn" aria-label="Edit" (click)="openDeleteSession(video.bookingid)"
                  *ngIf="video.bookedslotDate && isLoggedIn && video.isExpired === false">
                  <i class="fas fa-trash"></i>
                </button>
                <div class="rating-section mobile">
                  <button (click)="ratingSubmit(video.rating)" type="button" class="rating-btn"
                    [disabled]="!isPastDateAttended(video.bookedslotDate,video.bookedslotime,video.isbooked,video.Completed,video.isExpired)"
                    [ngClass]="{'disabled': !isPastDateAttended(video.bookedslotDate,video.bookedslotime,video.isbooked,video.Completed,video.isExpired)}">
                    Rate
                  </button>
                </div>
                <button class="feedback-btn" aria-label="Edit"
                  (click)="openVideoforSlot(video.lectureName, video.lectureId, chapter.moduleName, video.bookingid,  video.sessionid, 'editTrue' )"
                  *ngIf="video.bookedslotDate && isLoggedIn && isPastDateAttendedMissed(video.bookedslotDate,video.bookedslotime,video.isbooked,video.Completed,video.isExpired) && (video.isRescheduled === true)">
                  <i class="fas fa-edit"></i>
                </button>
                <button class="feedback-btn" aria-label="Edit"
                  (click)="openConfirmModal(video.lectureName, video.lectureId, chapter.moduleName, video.bookingid,  video.sessionid, 'editTrue' )"
                  *ngIf="video.bookedslotDate && isLoggedIn && isPastDateAttended(video.bookedslotDate,video.bookedslotime,video.isbooked,video.Completed,video.isExpired) && (video.isRescheduled === true)">
                  <i class="fas fa-edit"></i>
                </button>
                <div class="quiz-modal" *ngIf="confirmOpen">
                  <div class="modal-overlay"></div>

                  <div class="modal-content rebook-modal">

                    <div class="rebook-icon">
                      <i class="fas fa-calendar-check"></i>
                    </div>
                    <div class="rebook-info">
                      <i class="fas fa-info-circle"></i>
                      <span>
                        You have already attended this training session. Would you like to book this session again?
                      </span>
                    </div>

                    <div class="rebook-actions">
                      <button class="rebook-btn cancel-btn" (click)="closeConfirmModal()">
                        <i class="fas fa-times"></i>
                        Cancel
                      </button>

                      <button class="rebook-btn confirm-btn" (click)="openVideoforSlot(
                        livesessionname.lecturename,
                             livesessionname.lectureID,
                       livesessionname.moduleName,
                               livesessionname.bookingId,
                      livesessionname.sessionId,
                      livesessionname.editflag
                       )">
                        <i class="fas fa-calendar-plus"></i>
                        Book Again
                      </button>
                    </div>

                  </div>
                </div>
                <div class="quiz-modal" *ngIf="attendedAlert">
                  <div class="modal-overlay"></div>

                  <div class="modal-content rebook-modal">
                    <!-- Close Button -->
                    <button class="modal-close" (click)="closeattendedAlert()">
                      <i class="fas fa-times"></i>
                    </button>
                    <div class="attended-iconalert">
                      <i class="fas fa-circle-check"></i>
                    </div>
                    <div class="rebook-info1">
                      <i class="fas fa-circle-check"></i>
                      <span>
                        <strong> Session Attended</strong><br> Good job! 🎉 You attended this training session on<br>
                        <strong>{{selectSlotDate}}</strong> at <strong>{{selectedSlotTime}}</strong>. Keep learning and
                        growing!
                      </span>
                    </div>

                    <div class="rebook-actions">
                      <!-- <button class="rebook-btn cancel-btn" (click)="closeattendedAlert()">
                        <i class="fas fa-times"></i>
                        Cancel
                      </button> -->

                      <!-- <button class="rebook-btn confirm-btn confirm-feedback" (click)="feedbackopenwithsessionID()">

                        <i class="fas fa-comment-dots"></i>
                        Give Feedback
                      </button> -->
                    </div>

                  </div>

                </div>
                <div class="quiz-modal" *ngIf="slotnotBooked">
                  <div class="modal-overlay"></div>

                  <div class="modal-content rebook-modal">

                    <div class="rebook-icon">
                      <i class="fas fa-calendar-xmark"></i>
                    </div>
                    <div class="rebook-info">
                      <i class="fas fa-calendar-xmark"></i>
                      <span>
                        <strong> Session Over – No Booking </strong> <br>
                        Missed this session? No worries! 😊 Please contact our Help Desk, and we’ll be happy to assist
                        you.
                      </span>
                    </div>

                    <div class="rebook-actions">
                      <button class="rebook-btn cancel-btn" (click)="CloseNotbookedAlert()">
                        <i class="fas fa-times"></i>
                        Cancel
                      </button>

                      <button class="rebook-btn  confirm-btn" (click)="openHelpDesk()">
                        <i class="fas fa-headset"></i>
                        Help Desk
                      </button>
                    </div>

                  </div>
                </div>
                <div class="quiz-modal" *ngIf="missesalert">
                  <div class="modal-overlay"></div>

                  <div class="modal-content rebook-modal missedcard">

                    <!-- Missed Session Icon -->
                    <div class="missed-iconalert">
                      <i class="fas fa-calendar-xmark"></i>
                    </div>

                    <div class="rebook-info missed-info">
                      <i class="fas fa-circle-exclamation"></i>

                      <span>
                        <strong>Session Booked but Missed</strong><br>
                        Couldn’t make it to your booked session? No worries! 😊
                        Contact our <span class="help-desk">Help Desk</span>,
                        and we’ll help you get back on track.
                      </span>
                    </div>

                    <div class="rebook-actions">

                      <button class="rebook-btn cancel-btn" (click)="closedmissedAlert()">
                        <i class="fas fa-times"></i>
                        Cancel
                      </button>

                      <button class="rebook-btn  confirm-helpdesk" (click)="openHelpDesk()">
                        <i class="fas fa-headset"></i>
                        Help Desk
                      </button>

                    </div>

                  </div>
                </div>
              </span>
              <!-- <span class="status-icon onlyformobile" *ngIf="video.lectureType === 'livesession'">

                <button *ngIf="video.bookedslotDate === null || video.bookedslotDate === undefined && isLoggedIn"
                  class="join-btn" (click)="openVideoforSlot(video.lectureName,video.lectureId)">
                  <span class="live-dot"></span> Book
                </button>
                <button *ngIf="!isLoggedIn" class="join-btn" (click)="OpenLogin()">
                  <span class="live-dot"></span> Book
                </button>
                <button *ngIf="video.bookedslotDate && isLoggedIn" class="join-btn"
                  (click)="JoiSession(video.url,video.bookedslotDate,formatSlotDate(video.bookedslotDate))">
                  <span class="live-dotgreen"></span><strong>Join</strong>
                  <span class="onlyforDekstop">{{formatSlotDate(video.bookedslotDate)}}</span>
                </button>

              </span> -->
              <span class="time" *ngIf="video.lectureType !== 'livesession'">{{ video.time }}</span>

            </div>
            <!-- <div class="video-row">
              <span class="video-title">
               <img  src="Video-icon.png" class="pad1rem"/>
                this is live session
              </span>
              <span class="status-icon">

                <button class="join-btn" (click)="navgate()" >
                 <span class="live-dot"></span> Book Slot
                </button>

              </span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Confirmation Modal -->
  <div class="quiz-modal" *ngIf="showConfirmModal">
    <div class="modal-overlay"></div>
    <div class="modal-content quiz-page">
      <h3 class="quiz-title">
        {{ confirmData.title }}
      </h3>
      <p>{{ confirmData.message }}</p>

      <div class="quiz-actions">
        <button class="quiz-btn primary" (click)="onConfirm()">Yes</button>
        <button class="quiz-btn secondary" (click)="onCancel()">No</button>
      </div>
    </div>
  </div>
  <div class="quiz-modal" *ngIf="deleteModal">
    <div class="modal-overlay"></div>

    <div class="modal-content quiz-page">

      <div class="delete-icon">
        <i class="fas fa-trash-alt"></i>
      </div>

      <h3 class="quiz-title">
        Delete Booking?
      </h3>

      <p class="quiz-message">
        Are you sure you want to delete this booked slot?<br>
        This action cannot be undone.
      </p>

      <div class="warning-box">
        <i class="fas fa-exclamation-triangle"></i>
        <span>This will permanently remove your booking details.</span>
      </div>

      <div class="quiz-actions">
        <button class="quiz-btn secondary" (click)="closeDeleteSession()">
          <i class="fas fa-times"></i>
          Cancel
        </button>

        <button class="quiz-btn danger" (click)="onConfirmDelete()">
          <i class="fas fa-trash"></i>
          Yes, Delete Booking
        </button>
      </div>

    </div>
  </div>
  <!-- <div class="quiz-modal" *ngIf="feedbackModal">
    <div class="modal-overlay" (click)="feebackClose()"></div>


    <div class="modal-content quiz-page">
      <button class="modal-close" (click)="feebackClose()">
        <i class="fas fa-times"></i>
      </button>
      <app-feedback></app-feedback>
    </div>
    <div *ngIf="feedbackModal">
      <app-feedback></app-feedback>
    </div>
  </div> -->

</div>
<!-- <div *ngIf="feedbackModal">
      <app-feedback></app-feedback>
  </div> -->
<app-footer></app-footer>
<app-login #authModal (modalClosed)="onModalClosed()">
</app-login>